import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import { SIcon } from '@strana-artw/ui-kit';
export default {
  name: 'Step',
  components: {
    SIcon: SIcon
  },
  props: {
    icon: {
      type: String,
      default: undefined
    },
    label: {
      type: String,
      required: true
    },
    hint: {
      type: String,
      default: undefined
    },
    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['current', 'passed', 'normal'].includes(value);
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasIcon: function hasIcon() {
      return Boolean(this.icon) || this.type === 'passed';
    },
    iconName: function iconName() {
      return this.icon || 'check';
    },
    isCurrentStep: function isCurrentStep() {
      return this.type === 'current';
    },
    isPassedStep: function isPassedStep() {
      return this.type === 'passed';
    }
  }
};